import { useEffect, useState } from 'react'

// Returns `value` after it has stayed unchanged for `delay` ms.
// Useful for throttling things like search-as-you-type so we don't fire
// one API request per keystroke.
export default function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(handle)
  }, [value, delay])

  return debounced
}
